import { supabase } from '../supabaseClient'
import { filasSync, type EstadoGuardado } from './sync-estados'

const TODOS_LOS_ITEMS_IPER = ['GT-08']

interface IperAssessmentForCompliance {
  id: string
  nivel_riesgo_residual: number | null
}

export async function syncIperCompliance(companyId: string): Promise<void> {
  if (!companyId) return

  const { data: assessments } = await supabase
    .from('iper_assessments')
    .select('id, nivel_riesgo_residual')
    .eq('company_id', companyId)

  const assessmentList = (assessments ?? []) as IperAssessmentForCompliance[]

  let gt08Cumple = false

  if (assessmentList.length > 0) {
    gt08Cumple = assessmentList.every(a => a.nivel_riesgo_residual != null)
  }

  const cumpleActual: string[] = []
  if (gt08Cumple) cumpleActual.push('GT-08')

  const { data: existing } = await supabase
    .from('checklist_item_estados')
    .select('item_id, estado, auto_source')
    .eq('company_id', companyId)
    .in('item_id', TODOS_LOS_ITEMS_IPER)

  // Bloque 6, D: manda el módulo (sync-estados.ts): Cumple, En proceso si hay datos o Pendiente; nunca pisa un "No aplica".
  const rows = filasSync(companyId, TODOS_LOS_ITEMS_IPER, cumpleActual, assessmentList.length > 0 ? TODOS_LOS_ITEMS_IPER : [], (existing ?? []) as EstadoGuardado[], 'iper')

  if (rows.length === 0) return

  await supabase.from('checklist_item_estados').upsert(rows, { onConflict: 'company_id,item_id' })
}
